// react hook useI18n to use i18n in components
// sem usar o react-i18next

import { createContext, ReactNode, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import i18n from "./setup";
import { TFunction } from "i18next";

interface I18nContextProps {
  t: (key: string) => string;
  setLanguage: (lang: string) => void;
  lang: string;
}

export const I18nContext = createContext({} as I18nContextProps);

const formatLinkIntoTranslation = (value: string) => {
  let valueFormatted = value;
  // find urls on string and replace them with a tag
  const regex = /((http|https):\/\/[^\s]+)/g;

  const matches = value.matchAll(regex);

  for (const match of matches) {
    const [fullMatch] = match;
    valueFormatted = valueFormatted.replace(
      fullMatch,
      `<a target="_blank" href="${fullMatch}">${fullMatch}</a>`
    );
  }

  return <i dangerouslySetInnerHTML={{ __html: valueFormatted }} />;
};

const handleTranslation = (t: TFunction) => (key: string) => {
  const value = t(key, { context: "formatting" });

  return formatLinkIntoTranslation(value);
};

export const Provider = ({ children }: { children: ReactNode }) => {
  const [cookies] = useCookies(["i18next"]);

  const [currLang, setCurrLang] = useState(i18n.language);
  const [t, setT] = useState<TFunction>();

  useEffect(() => {
    if (cookies.i18next) {
      i18n.changeLanguage(cookies.i18next);
    }
  }, [cookies.i18next]);

  return (
    <I18nContext.Provider
      value={{
        t: (t as TFunction) ?? handleTranslation(i18n.t),
        setLanguage: async (lang: string) => {
          try {
            await i18n.changeLanguage(lang);

            setT(handleTranslation(i18n.t) as TFunction);
            setCurrLang(lang);
          } catch (err) {
            console.error("Failed to change language", err);
          }
        },
        lang: currLang,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
};
